import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faCheckCircle
} from "@fortawesome/pro-light-svg-icons";
import MessagePanelStyle from "../styles/MessagePanelStyle";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface MessagePanelProps {
  title: string;
  message: string;
  mode: "info" | "error" | "warning" | "success";
}

const MessagePanel = (props: MessagePanelProps) => {
  const { message: text, mode, title } = props;

  const getIcon = () => {
    if (mode === "error") return faExclamationCircle as IconProp;
    else if (mode === "warning") return faExclamationTriangle as IconProp;
    else if (mode === "success") return faCheckCircle as IconProp;
    return faInfoCircle as IconProp;
  };

  return (
    <MessagePanelStyle mode={props.mode}>
      <div className="title">
        <div className="icon">
          <FontAwesomeIcon icon={getIcon()} />
        </div>
        <span className="body3">{title}</span>
      </div>
      <div className="message">
        <span className="body2">{text}</span>
      </div>
    </MessagePanelStyle>
  );
};

export default MessagePanel;
